<body>
<!-- ============================================================== -->
<!-- Preloader - style you can find in spinners.css -->
<!-- ============================================================== -->
<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->
  <div id="main-wrapper" class="align-content-center" style="width: 100%">
    <div style="width: 100%; align-content: center; margin-top: 10%; margin-bottom: 10%">
      <div class="login-div">
        <mat-card>
          <mat-card-title style="display: inline;margin-left: 74px">Registra un account</mat-card-title>
          <button style="display: inline; margin-left: 42%; font-size: 17px" mat-button>
            <a class="nav-link" href="/home">{{'login.button-home'|translate}}</a>
          </button>
          <br><br>
          <form [formGroup]="formGroup" *ngIf="!signedIn">
            <mat-form-field style="width: 80%; margin-left: 10%">
              <input matInput placeholder="{{'sign-in.name-input-placeholder'|translate}} e cognome" formControlName="name"
                     [errorStateMatcher]="matcher" value="" required>
            </mat-form-field>
            <mat-form-field style="width: 80%; margin-left: 10%">
              <input matInput placeholder="{{'login.email-placeholder'|translate}}" formControlName="email"
                     [errorStateMatcher]="matcher" value="" required>
              <mat-error *ngIf="formGroup.get('email').hasError('email') && !formGroup.get('email').hasError('required')">
                {{'login.email-not-valid'|translate}}
              </mat-error>
              <mat-error *ngIf="formGroup.get('email').hasError('required')">
                {{'login.null-value-error'|translate}}
              </mat-error>
            </mat-form-field>
            <mat-form-field style="width: 80%; margin-left: 10%">
              <input type="password" matInput placeholder="{{'login.password-placeholder'|translate}}" formControlName="password" value = ""
                     [errorStateMatcher]="matcher" required>
              <mat-error *ngIf="formGroup.get('password').hasError('minlength') && !formGroup.get('password').hasError('required')" >
                {{'sign-in.password-rule-1'|translate}}
              </mat-error>
              <mat-error *ngIf="formGroup.get('password').hasError('required')">
                {{'login.null-value-error'|translate}}
              </mat-error>
            </mat-form-field>
            <mat-form-field style="width: 80%; margin-left: 10%">
              <input type="password" matInput placeholder="{{'sign-in.retype-password-placeholder'|translate}}"
                     formControlName="password_check" value = ""
                     [errorStateMatcher]="matcher" required>
              <mat-error *ngIf="formGroup.get('password_check').hasError('minlength') && !formGroup.get('password').hasError('required')" >
                {{'sign-in.password-rule-1'|translate}}
              </mat-error>
              <mat-error *ngIf="formGroup.get('password_check').hasError('required')">
                {{'login.null-value-error'|translate}}
              </mat-error>
              <mat-error *ngIf="formGroup.get('password').value != formGroup.get('password_check').value">
                {{'sign-in.passwords-error'|translate}}
              </mat-error>
            </mat-form-field>
            <mat-form-field style="width: 58%; margin-left: 10%">
              <input matInput placeholder="Inserisci l'indirizzo" formControlName="indirizzo"
                     [errorStateMatcher]="matcher" value="" required>
              <mat-error *ngIf="formGroup.get('indirizzo').hasError('required')">
                L'indirizzo è richiesto
              </mat-error>
            </mat-form-field>
            <mat-form-field style="width: 20%; margin-left: 2%">
              <input matInput placeholder="Inserisci il numero civico" formControlName="civico"
                     [errorStateMatcher]="matcher" value="" required>
              <mat-error *ngIf="formGroup.get('civico').hasError('required')">
                Il numero civico è richiesto
              </mat-error>
            </mat-form-field>
            <mat-form-field style="width: 58%; margin-left: 10%">
              <input matInput placeholder="Inserisci la città" formControlName="citta"
                     [errorStateMatcher]="matcher" value="" required>
              <mat-error *ngIf="formGroup.get('citta').hasError('required')">
                La città è richiesta
              </mat-error>
            </mat-form-field>
            <mat-form-field style="width: 20%; margin-left: 2%">
              <input matInput placeholder="Inserisci il CAP" formControlName="cap"
                     [errorStateMatcher]="matcher" value="" required>
              <mat-error *ngIf="formGroup.get('cap').hasError('required')">
                Il CAP è richiesto
              </mat-error>
            </mat-form-field>
            <mat-form-field style="width: 80%; margin-left: 10%">
              <input matInput placeholder="Inserisci il codice fiscale" formControlName="fisc_code"
                     [errorStateMatcher]="matcher" value="" required>
              <mat-error *ngIf="formGroup.get('fisc_code').hasError('pattern') &&
               !formGroup.get('fisc_code').hasError('required')">
                Codice Fiscale non valido
              </mat-error>
              <mat-error *ngIf="formGroup.get('fisc_code').hasError('required')">
                Il Codice Fiscale è richiesto
              </mat-error>
            </mat-form-field>
            <br>
            <!--
            <div style="margin-left: 10%; width: 80%;" *ngIf="!affiliato">
              <mat-checkbox style="margin-right: 10px" #checkbox (change)="changesCheck(checkbox)"></mat-checkbox>
              {{'sign-in.partner-label'|translate}}
            </div>
            -->
            <br><br>
            <button (keyup.enter)="signInClick()" (click)="signInClick()"
                    style="width: 80%; margin-left: 10%; display: inline"
                    class="btn btn-primary" type="button" [disabled]="loading">
              <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true" *ngIf="loading"></span>
              Registra un account
            </button>
            <br><br>
            <p style="width: 80%; margin-left: 10%;font-size: 11px">Registrandoti dichiari di aver letto ed accettato i
              <a href="../../assets/privacy.pdf" target="_blank">termini e condizioni</a>
          </form>
          <div *ngIf="signedIn">
            <p *ngIf="signInResponse.result">{{'sign-in.result-1'|translate}}</p>
            <p *ngIf="!signInResponse.result">{{'sign-in.result-2'|translate}}</p>
            <p *ngIf="!signInResponse.result">{{signInResponse.message}}</p>
          </div>
        </mat-card>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</body>
